import __base_store from '@/store/__base_store'

/**
 * Store de condiciones de ítems de Mercado Libre (modelo `meli_item_condition`) construido desde el factory común.
 */
export default __base_store({
	state: {
		model_name: 'meli_item_condition',
	},
})

